<template>
  <div class="box-body">
    <div class="row m-b-15">
      <div class="row center-block">
        <div class="col-md-12">
          <div>
            <div class="p-sm-10-p">
              <h3 class="p-a-10 page-title">{{ activityInfo.title }}</h3>
              <div v-show="activityInfo.info">
                <div class="alert alert-info-bg">
                  <span class="text-danger">＊</span>
                  <span v-text="activityInfo.info" />
                </div>
              </div>
            </div>
            <div class="box-body form-center" v-if="info.info.activity_id && activity.is_enable.value === 0 && !info.info.has_used">
              <div class="text-right m-b-10">
                <button class="btn btn-danger" data-target="#delModal" data-toggle="modal"><i class="fa fa-trash"></i></button>
              </div>
            </div>
            <div class="box-body form-center"  v-if="info.info.has_used">
              <h5 class="text-danger"><i class="fa fa-star"></i>&nbsp;活動已被使用，無法編輯限制規則、折扣規則，也無法刪除已參與店家 (可新增店家)</h5>
            </div>
            <div class="box-body form-left">
              <div>
                <div class="input-group">
                  <span class="input-group-addon" style="padding-right:25px"><span class="text-red">＊ </span>活動名稱</span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.name" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon" style="padding-right:25px">
                    <span class="text-red">＊ </span>活動啟用
                  </span>
                  <div>
                    <multiselect
                      v-model="activity.is_enable"
                      :options="enableOptions"
                      :searchable="true"
                      :allow-empty="false"
                      :close-on-select="true"
                      placeholder="啟用"
                      :show-labels="false"
                      :multiple="false"
                      label="label"
                      track-by="label"
                    />
                  </div>
                </div>
                <br>
              </div>
              <div v-if="getRoleType === 99">
                <div class="input-group">
                  <span class="input-group-addon" style="padding-right: 45px">
                    <span class="text-red">＊ </span>擁有者
                  </span>
                  <div>
                    <multiselect
                      v-model="activity.owner_type"
                      :options="ownerTypeOptions"
                      :searchable="true"
                      :allow-empty="false"
                      :close-on-select="true"
                      placeholder="擁有者"
                      :show-labels="false"
                      :multiple="false"
                      label="label"
                      track-by="label"
                    />
                  </div>
                </div>
                <br>
              </div>

            </div>
            <div class="box-body form-right">
              <div v-show="getRoleType === 99 || (getRoleType === 30 && !info.info.activity_id)">
                <div class="input-group">
                  <span class="input-group-addon" style="padding-right:25px">
                    <span class="text-red">＊ </span>參與品牌
                  </span>
                  <div>
                    <multiselect
                      v-model="brandSelect"
                      :options="brandBrief"
                      :searchable="true"
                      :allow-empty="false"
                      :close-on-select="true"
                      placeholder="品牌"
                      :show-labels="false"
                      :multiple="false"
                      label="label"
                      track-by="label"
                    />
                  </div>
                </div>
                <br>
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon" style="padding-right:25px">
                    <span class="text-red">＊ </span>你訂平台
                  </span>
                  <div @click="showWarning">
                    <multiselect
                      v-model="activity.is_platform_visible"
                      :options="enableOptions"
                      :searchable="true"
                      :allow-empty="false"
                      :close-on-select="true"
                      placeholder="啟用"
                      :show-labels="false"
                      :multiple="false"
                      label="label"
                      track-by="label"
                      :disabled="getRoleType !== 99"
                    />
                  </div>
                </div>
                <br>
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon tip-icon-block" style="padding-right:25px">
                    <span class="text-red">＊ </span>
                    街口平台
                  </span>
                  <span data-toggle="tooltip" class="tip-icon" data-placement="bottom" title="與街口支付APP合作之你訂獨家功能，有興趣可洽業務窗口。若未簽約合作請勿啟用。">
                    <i class="fa fa-question-circle" aria-hidden="true"></i>
                  </span>
                  <div @click="showWarning">
                    <multiselect
                      v-model="activity.dedicated_visible_setting"
                      :options="enableOptions"
                      :searchable="true"
                      :allow-empty="false"
                      :close-on-select="true"
                      placeholder="啟用"
                      :show-labels="false"
                      :multiple="false"
                      label="label"
                      track-by="label"
                      :disabled="getRoleType !== 99"
                    />
                  </div>
                </div>
                <br>
              </div>

            </div>
            <div class="col-xs-12 p-sm-10-p">
              <div class="m-b-15">
                <span class="text-danger">＊</span>
                <span>{{ activityInfo.description }}</span>
              </div>
              <div class="input-group">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>
                  活動說明
                </span>
                <textarea
                  class="form-control"
                  placeholder="活動說明"
                  v-model="activity.description"
                  maxlength="256"
                  style="height: 160px"
                />
              </div>
            </div>
            <div>
              <div class="col-xs-12 p-sm-10-p">
                <br />
                <h3 class="sub-title">活動時間設定</h3>
                <div class="broder-all">
                  <div>
                    <div class="input-group">
                      <span class="input-group-addon" style="padding-right:25px">
                        <span class="text-red">＊ </span>活動時間
                      </span>
                      <div>
                        <select class="form-control" v-model="activity.aTime.type">
                          <option :value="1">依據消費者下訂時間</option>
                          <option :value="2">依據消費者的下訂時間+預計取餐時間</option>
                        </select>
                      </div>
                    </div>
                    <br>
                  </div>
                  <div class="p-x-10">
                    <div class="input-group">
                      <span class="input-group-addon">
                        <span class="text-red">＊ </span>活動開始時間
                      </span>
                      <date-time-picker class="w-100" :date="activity.aTime.start" :option="timeoption" :limit="startLimit"></date-time-picker>
                    </div>
                    <br />
                  </div>
                  <div class="p-x-10">
                    <div class="input-group">
                      <span class="input-group-addon">
                        <span class="text-red">＊ </span>活動結束時間
                      </span>
                      <date-time-picker class="w-100" :date="activity.aTime.end" :option="timeoption" :limit="endLimit"></date-time-picker>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 p-sm-10-p">
              <br />
              <h4>參與店家</h4>
              <div>
                <div v-for="(storeClass, index) in storeClassList" class="m-r-5 m-b-10 inline-block">
                  <button class="btn btn-default" :class="{'active': curId === storeClass.id}" @click="clickOption(storeClass)">
                    {{storeClass.name}}
                  </button>
                </div>
              </div>
              <!-- 參與店家 -->
              <muti-select-two :setting="addStoresSetting" :reNew="reNew" :reSet="reSet"></muti-select-two>
            </div>
            <div class="col-xs-12 p-sm-10-p">
              <h3 class="sub-title">週期/時段活動設定</h3>
              <div class="text-left">
                <button class="btn btn-success" @click="addProcessTime">新增某時段的製作時間</button>
              </div>
              <div
                v-for="(process, pIndex) in timeSettingList"
                :key="pIndex"
                class="m-t-10 process-time-block"
              >
                <div
                  v-if="pIndex !== 0"
                  class="text-right m-b-10"
                >
                  <button
                    class="btn btn-danger"
                    @click="removeListItem(timeSettingList, pIndex)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
                <div>
                  <div class="m-b-15">
                    <span class="text-danger">＊</span>
                    <span>可指定折扣活動時段：如週一到週三或每日14:00~16:00，若不指定可不需填寫</span>
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon"><span class="text-red">＊ </span>時間類型</span>
                    <div class="form-group">
                      <select class="form-control" v-model="process.value_type" @change="clearProcess(process)">
                        <option :value="0">無指定</option>
                        <option :value="1">日期</option>
                        <option :value="2">星期</option>
                      </select>
                    </div>
                  </div>
                  <br>
                </div>
                <div v-if="process.value_type === 2">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <span class="text-red">＊ </span>開始
                    </span>
                    <div>
                      <multiselect v-model="process.start_value"
                                   placeholder="新增星期" label="label" track-by="value" :options="offdaySetting.options.weekDay"
                                   :multiple="false" :allow-empty="true"></multiselect>
                    </div>
                  </div>
                  <br />
                </div>
                <div v-if="process.value_type === 1">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <span class="text-red">＊ </span>開始
                    </span>
                    <div>
                      <input class="form-control" placeholder="日期(數字1~31)" type="text" v-model="process.start_value" maxlength="2">
                    </div>
                  </div>
                  <br />
                </div>
                <div v-if="process.value_type === 2">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <span class="text-red">＊ </span>結束
                    </span>
                    <div>
                      <multiselect v-model="process.end_value"
                                   placeholder="新增星期" label="label" track-by="value" :options="offdaySetting.options.weekDay"
                                   :multiple="false" :allow-empty="true"></multiselect>
                    </div>
                  </div>
                  <br />
                </div>
                <div v-if="process.value_type === 1">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <span class="text-red">＊ </span>結束
                    </span>
                    <div>
                      <div>
                        <input class="form-control" placeholder="日期(數字1~31)" type="text" v-model="process.end_value" maxlength="2">
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <span class="text-red">＊ </span>時段設定
                    </span>
                    <div>
                      <select class="form-control" v-model="process.time_type" @change="changeTimeType(process)">
                        <option :value="timeType.value" v-for="timeType in timeTypeOption">{{timeType.label}}</option>
                      </select>
                    </div>
                  </div>
                  <br />
                </div>
                <div class="text-left" v-if="process.time_type === 2"><button class="btn btn-primary" @click="addItemTime(process)">加入時間</button></div>
                <table class="table table-bordered table-striped dataTable" v-if="process.time_type === 2">
                  <thead class="bg-primary">
                  <tr>
                    <td>開始時間</td>
                    <td>結束時間</td>
                    <td></td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, iIndex) in process.time_interval">
                    <td>
                      <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.start_time">
                    </td>
                    <td>
                      <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.end_time">
                    </td>
                    <td>
                      <button class="btn btn-danger" v-if="iIndex > 0" @click="removeListItem(process.time_interval, iIndex)"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <br>
            </div>
            <div class="col-xs-12 p-sm-10-p">
              <div>
                <h3 class="sub-title">活動規則</h3>
                <div class="m-b-15">
                  <span class="text-danger">＊</span>
                  <span>若無特殊限制規則，可不進行異動</span>
                </div>
              </div>
            </div>
            <div class="box-body form-left" v-if="info.info.has_used">
              <div  v-if="activity.strategy_data.limit.order_types.length">
                <div class="input-group">
                  <span class="input-group-addon">
                    訂單類型
                  </span>
                  <div class="form-control form-info">
                    <label class="label label-success m-r-5" v-for="orderType in activity.strategy_data.limit.order_types">
                      {{orderType.label}}
                    </label>
                  </div>
                </div>
                <br>
              </div>
              <div v-if="activity.strategy_data.limit.order_methods.length" >
                <div class="input-group">
                  <span class="input-group-addon">
                    訂單方案
                  </span>
                  <div class="form-control form-info">
                    <label class="label label-success m-r-5"  v-for="orderMethod in activity.strategy_data.limit.order_methods">
                      {{orderMethod.label}}
                    </label>
                  </div>
                </div>
                <br>
              </div>
              <div v-if="activity.strategy_data.limit.delivery_types.length">
                <div class="input-group">
                  <span class="input-group-addon">
                    取貨方式
                  </span>
                  <div class="form-control form-info">
                    <label class="label label-success m-r-5"  v-for="deliveryType in activity.strategy_data.limit.delivery_types">
                      {{deliveryType.label}}
                    </label>
                  </div>
                </div>
                <br>
              </div>
              <div v-if="activity.strategy_data.limit.trade_types.length">
                <div class="input-group">
                  <span class="input-group-addon">
                    付款方式
                  </span>
                  <div class="form-control form-info">
                    <label class="label label-success m-r-5" v-for="tradeType in activity.strategy_data.limit.trade_types">
                      {{tradeType.label}}
                    </label>
                  </div>
                </div>
                <br>
              </div>
            </div>
            <div class="box-body form-left" v-else>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    訂單類型
                  </span>
                  <div>
                    <multiselect
                      v-model="activity.strategy_data.limit.order_types"
                      :options="orderType"
                      :searchable="false"
                      :allow-empty="true"
                      :close-on-select="false"
                      :placeholder="getPlaceholder(orderType)"
                      :show-labels="false"
                      :multiple="true"
                      label="label"
                      track-by="label"
                    />
                  </div>
                </div>
                <br>
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    訂單方案
                  </span>
                  <div>
                    <multiselect
                      v-model="activity.strategy_data.limit.order_methods"
                      :options="orderMethod"
                      :searchable="true"
                      :allow-empty="true"
                      :close-on-select="false"
                      :placeholder="getPlaceholder(orderMethod)"
                      :show-labels="false"
                      :multiple="true"
                      label="label"
                      track-by="label"
                    >
                    </multiselect>
                  </div>
                </div>
                <br>
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    取貨方式
                  </span>
                  <div>
                    <multiselect
                      v-model="activity.strategy_data.limit.delivery_types"
                      :options="deliveryType"
                      :searchable="false"
                      :allow-empty="true"
                      :close-on-select="false"
                      :placeholder="getPlaceholder(deliveryType)"
                      :show-labels="false"
                      :multiple="true"
                      label="label"
                      track-by="label"
                    >
                    </multiselect>
                  </div>
                </div>
                <br>
              </div>
              <!--
                issue: ECMS-折扣管理-新增說明文字
                refs: 165277092
                des: hidden
              -->
              <div v-show="false">
                <div class="input-group">
                  <span class="input-group-addon">
                    付款方式
                  </span>
                  <div>
                    <multiselect
                      v-model="activity.strategy_data.limit.trade_types"
                      :options="tradeType"
                      :searchable="false"
                      :allow-empty="true"
                      :close-on-select="false"
                      :placeholder="getPlaceholder(tradeType)"
                      :show-labels="false"
                      :multiple="true"
                      label="label"
                      track-by="label"
                    />
                  </div>
                </div>
                <br>
              </div>
            </div>
            <div
              class="box-body form-right"
              v-if="info.info.has_used"
            >
              <div v-if="activity.strategy_data.limit.min_product_money">
                <div class="input-group">
                  <span class="input-group-addon">訂單最低應付金額</span>
                  <div class="form-control form-info">
                    {{ activity.strategy_data.limit.min_product_money }}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="activity.strategy_data.limit.min_product_amount">
                <div class="input-group">
                  <span class="input-group-addon">
                    <span>訂單最低購買數量(單位：個)</span>
                    <span
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="若不限制可不填寫"
                    >
                      <i class="fa fa-question-circle" aria-hidden="true" />
                    </span>
                  </span>
                  <div class="form-control form-info">
                    {{ activity.strategy_data.limit.min_product_amount }}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="false">
                <div class="input-group">
                  <span class="input-group-addon">限制子單(跟團單)最低訂單數(單位：筆)</span>
                  <div class="form-control form-info">
                    {{ activity.strategy_data.limit.min_sub_order_amount }}
                  </div>
                </div>
                <br />
              </div>
            </div>
            <div
              class="box-body form-right"
              v-else
            >
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    <span>訂單最低應付金額(單位：元)</span>
                    <span
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="訂單需達到最低金額門檻才會觸發活動，若不限制金額可不填寫"
                    >
                      <i class="fa fa-question-circle" aria-hidden="true" />
                    </span>
                  </span>

                  <input
                    class="form-control"
                    placeholder="包含扣除折價"
                    type="text"
                    v-model="activity.strategy_data.limit.min_product_money"
                    maxlength="45"
                  />
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    <span>訂單最低購買數量(單位：個)</span>
                    <span
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="若不限制可不填寫"
                    >
                      <i class="fa fa-question-circle" aria-hidden="true" />
                    </span>
                  </span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.strategy_data.limit.min_product_amount" maxlength="45">
                </div>
                <br />
              </div>
              <!--
                issue: ECMS-折扣管理-新增說明文字
                refs: 165277092
                des: hidden
              -->
              <div v-show="false">
                <div class="input-group">
                  <span class="input-group-addon">限制子單(跟團單)最低訂單數(單位：筆)</span>
                  <input
                    class="form-control"
                    placeholder=""
                    type="text"
                    v-model="activity.strategy_data.limit.min_sub_order_amount"
                    maxlength="45"
                  />
                </div>
                <br />
              </div>
            </div>
            <div class="col-xs-12 p-sm-10-p form-center box-body">
              <div style="margin-bottom: 20px">
                <h3 class="sub-title">折扣規則</h3>
                <div v-show="activityInfo.strategyDataLimitOrderTypes" class="m-b-15">
                  <span class="text-danger">＊</span>
                  <span>{{ activityInfo.strategyDataLimitOrderTypes }}</span>
                </div>
              </div>
              <div
                v-if="ruleCode === 'SD00001'"
                class="m-t-10"
              >
                <div class="input-group">
                  <span class="input-group-addon">
                    <span class="text-red">＊</span>
                    折扣滿足總數 (買X送一
                  </span>
                  <span
                    class="form-control form-info"
                    v-if="info.info.has_used"
                  >
                    {{ activity.strategy_data.setting.amount_unit }}
                  </span>
                  <input
                    v-else
                    class="form-control"
                    placeholder=""
                    type="text"
                    v-model="activity.strategy_data.setting.amount_unit"
                  />
                </div>
                <br />
              </div>
              <div
                v-else-if="ruleCode === 'SD00002'"
                class="m-t-10"
              >
                <div class="m-b-15">
                  <span class="text-danger">＊</span>
                  <span>{{ activityInfo.strategyDataSettingOneMaxDiscountTips }}</span>
                </div>
                <div class="input-group">
                  <span
                    class="input-group-addon"
                    style="padding-right: 68px"
                  >
                    最大折扣金額
                  </span>
                  <span
                    class="form-control form-info"
                    v-if="info.info.has_used"
                  >
                    {{ activity.strategy_data.setting.one_max_discount }}
                  </span>
                  <input
                    class="form-control"
                    placeholder="無限制為空"
                    type="text"
                    v-model="activity.strategy_data.setting.one_max_discount"
                    v-else
                  />
                </div>
                <br />
              </div>
              <div
                v-else-if="ruleCode === 'SD00003'"
                class="m-t-10"
              >
                <div class="input-group">
                  <span class="input-group-addon" style="padding-right: 60px"><span class="text-red">＊ </span>折扣滿足總數 (買X送Y，X數值)</span>
                  <span class="form-control form-info" v-if="info.info.has_used">{{activity.strategy_data.setting.amount_unit}}</span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.strategy_data.setting.amount_unit" v-else>
                </div>
                <br />
                <div class="input-group">
                  <span class="input-group-addon" style="padding-right: 60px"><span class="text-red">＊ </span>折扣贈送總數 (買X送Y，Y數值)</span>
                  <span class="form-control form-info" v-if="info.info.has_used">{{activity.strategy_data.setting.ratio}}</span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.strategy_data.setting.ratio" v-else>
                </div>
                <br />
                <div class="input-group">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>
                    商品限制最低單價
                    <span
                      v-show="activityInfo.strategyDataSettingLowestUnitPriceTips"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      :title="activityInfo.strategyDataSettingLowestUnitPriceTips"
                    >
                      <i
                        class="fa fa-question-circle"
                        aria-hidden="true"
                      />
                    </span>
                  </span>
                  <span
                    v-if="info.info.has_used"
                    class="form-control form-info"
                  >
                    {{ activity.strategy_data.setting.lowest_unit_price }}
                  </span>
                  <input
                    v-else
                    class="form-control"
                    placeholder=""
                    type="text"
                    v-model="activity.strategy_data.setting.lowest_unit_price"
                  />
                </div>
                <br />
              </div>
              <div
                v-else-if="ruleCode === 'SD00004'"
                class="m-t-10"
              >
                <div class="m-b-15">
                  <span class="text-danger">＊</span>
                  <span>{{ activityInfo.strategyDataSettingPercentValueTips }}</span>
                </div>
                <div class="input-group">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>
                    折數設定
                  </span>
                  <input
                    class="form-control"
                    placeholder=""
                    type="text"
                    v-model="activity.strategy_data.setting.percent_value"
                  />
                </div>
                <br />
                <div class="m-b-15">
                  <span class="text-danger">＊</span>
                  <span>{{ activityInfo.strategyDataSettingRoundPolicyTips }}</span>
                </div>
                <div class="input-group">
                  <span
                    class="input-group-addon"
                    style="padding-right: 138px"
                  >
                    <span class="text-red">＊ </span>
                    折扣金額小數點進位方式
                  </span>
                  <div class="">
                    <multiselect
                      v-model="activity.strategy_data.setting.round_policy"
                      :options="roundPolicy"
                      :searchable="false"
                      :allow-empty="true"
                      :close-on-select="false"
                      placeholder="折扣金額小數點進位方式"
                      :show-labels="false"
                      :multiple="false"
                      label="label"
                      track-by="label"
                    />
                  </div>
                </div>
                <br />
                <div class="input-group">
                  <span
                    class="input-group-addon" style="padding-right:145px"
                  >
                    <span class="text-red">＊ </span>
                    是否忽略折讓金額(A+B)
                    <span
                      v-show="activityInfo.strategyDataSettingIgnoreAllowanceTips"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      :title="activityInfo.strategyDataSettingIgnoreAllowanceTips"
                    >
                      <i
                        class="fa fa-question-circle"
                        aria-hidden="true"
                      />
                    </span>
                  </span>
                  <div class="">
                    <multiselect
                      v-model="activity.strategy_data.setting.ignore_allowance"
                      :options="ignoreAllowance"
                      :searchable="false"
                      :allow-empty="true"
                      :close-on-select="false"
                      placeholder="是否忽略折讓(A+B)金額"
                      :show-labels="false"
                      :multiple="false"
                      label="label"
                      track-by="label"
                    />
                  </div>
                </div>
                <br />
              </div>
              <div class="m-t-10" v-else-if="ruleCode === 'SD00005'">
                <div class="input-group">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>
                    買X份商品享折扣，X值(單位：份)
                    <span
                      v-show="activityInfo.strategyDataSettingAmountUnitTips"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      :title="activityInfo.strategyDataSettingAmountUnitTips"
                    >
                      <i
                        class="fa fa-question-circle"
                        aria-hidden="true"
                      />
                    </span>
                  </span>
                  <input
                    class="form-control"
                    placeholder=""
                    type="text"
                    v-model="activity.strategy_data.setting.amount_unit"
                  />
                </div>
                <br />
                <div class="input-group">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>
                    折扣金額，Y值(單位：元)
                    <span
                      v-show="activityInfo.strategyDataSettingDiscountUnitTips"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      :title="activityInfo.strategyDataSettingDiscountUnitTips"
                    >
                      <i
                        class="fa fa-question-circle"
                        aria-hidden="true"
                      />
                    </span>
                  </span>
                  <input
                    class="form-control"
                    placeholder=""
                    type="text"
                    v-model="activity.strategy_data.setting.discount_unit"
                  />
                </div>
                <br />
                <div class="input-group">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>
                    商品限制最低單價
                    <span
                      v-show="activityInfo.strategyDataSettingLowestUnitPriceTips"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      :title="activityInfo.strategyDataSettingLowestUnitPriceTips"
                    >
                      <i
                        class="fa fa-question-circle"
                        aria-hidden="true"
                      />
                    </span>
                  </span>
                  <input
                    class="form-control"
                    placeholder=""
                    type="text"
                    v-model="activity.strategy_data.setting.lowest_unit_price"
                  />
                </div>
                <br />
              </div>
              <div style="margin-bottom: 20px" v-if="!info.info.has_used">
                <template v-if="ruleCode === 'SD00001' || ruleCode === 'SD00003' || ruleCode === 'SD00004' || ruleCode === 'SD00005'">
                  <h3 class="sub-title">排除商品選擇</h3>
                  <div class="m-b-15">
                    <span class="text-danger">＊</span>
                    <span>若有塑膠袋等，記得勾選。</span>
                  </div>
                  <div class="m-b-15">
                    <span class="text-danger">＊</span>
                    <span>如排除商品為部分門市限定上架，需使用選擇參與店家找到該門市後再點選排除。 </span>
                  </div>
                  <div class="m-b-15">
                    <div class="alert alert-info-bg">
                      <span class="text-danger">＊</span>
                      <span>請注意：先選擇完店家菜單後，再選擇要<span class="text-danger">排除</span>的商品</span>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <h3 class="sub-title">折扣商品選擇</h3>
                  <div class="m-b-15">
                    <span class="text-danger">＊</span>
                    <span>擇一選擇門市並選取需折扣的商品。</span>
                  </div>
                </template>
              </div>
              <div class="" v-if="!info.info.has_used">
                <div class="input-group">
                  <span
                    class="input-group-addon"
                    :style="selectStorePadding"
                  >
                    <span class="text-red">＊ </span>
                    選擇店家菜單
                    <span
                      v-show="this.$route.query.rule_code === 'SD00002'"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="擇一選擇門市並選取需折扣的商品。"
                    >
                      <i class="fa fa-question-circle" aria-hidden="true" />
                    </span>
                  </span>
                  <multiselect
                    v-model="storeSelect"
                    :options="storeList"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="店家"
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="label"
                  />
                </div>
                <br />
              </div>
              <menu-discount :menuId="menuSelect.value" @addProdToList="addExProdToList" :showWord="'排除'" v-if="ruleCode === 'SD00001' && !info.info.has_used"></menu-discount>
              <menu-discount :menuId="menuSelect.value" @addProdToList="addProdToList" :showWord="'加入'" v-else-if="ruleCode === 'SD00002' && !info.info.has_used"></menu-discount>
              <menu-discount :menuId="menuSelect.value" @addProdToList="addExProdToList" :showWord="'排除'" v-else-if="ruleCode === 'SD00004' && !info.info.has_used"></menu-discount>
              <menu-discount :menuId="menuSelect.value" @addProdToList="addExProdToList" :showWord="'排除'" v-else-if="ruleCode === 'SD00005' && !info.info.has_used"></menu-discount>
              <menu-discount :menuId="menuSelect.value" @addProdToList="addExProdToList3" :showWord="'排除'" v-else-if="!info.info.has_used"></menu-discount>
              <!--{{activity.strategy_data.setting.product_info}}-->
              <div class="m-t-10" v-if="activity.strategy_data.store_exception_items[0].products.length && (ruleCode === 'SD00001' || ruleCode === 'SD00004' || ruleCode === 'SD00005')">
                <table class="table table-bordered table-striped dataTable">
                  <thead class="bg-primary">
                  <tr>
                    <td>＃</td>
                    <td>商品</td>
                    <td>商品料號</td>
                    <td v-if="!info.info.has_used"></td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(aProduct, aIndex) in activity.strategy_data.store_exception_items[0].products">
                    <td>
                      {{aIndex + 1}}
                    </td>
                    <td>
                      {{aProduct.product_name}}
                    </td>
                    <td>
                      <div class="text-primary c-pointer" data-toggle="modal" v-if="$route.params.activity_id"
                           data-target="#storeProdModal" @click="getStoreProd(aProduct)">{{aProduct.vendor_custom_id}}</div>
                      <div v-else>{{aProduct.vendor_custom_id}}</div>
                    </td>
                    <td v-if="!info.info.has_used">
                      <button class="btn btn-danger" @click="removeListItem(activity.strategy_data.store_exception_items[0].products, aIndex)"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.setting.product_info.length && ruleCode === 'SD00002'">
                <table class="table table-bordered table-striped dataTable">
                  <thead class="bg-primary">
                  <tr>
                    <td>＃</td>
                    <td>商品</td>
                    <td>商品料號</td>
                    <td>折扣規則</td>
                    <td v-if="!info.info.has_used"></td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(aProduct, aIndex) in activity.strategy_data.setting.product_info">
                    <td>
                      {{aIndex + 1}}
                    </td>
                    <td>
                      {{aProduct.product_name}}
                    </td>
                    <td>
                      <div class="text-primary c-pointer" data-toggle="modal" v-if="$route.params.activity_id"
                           data-target="#storeProdModal" @click="getStoreProd(aProduct)">{{aProduct.vendor_custom_id}}</div>
                      <div v-else>{{aProduct.vendor_custom_id}}</div>
                    </td>
                    <td v-if="!info.info.has_used">
                      購買&nbsp;&nbsp;<input class="form-control w-90 inline-block" placeholder="" type="text" v-model="aProduct.amount_unit" @keypress="returnNum">&nbsp;&nbsp;個
                      折&nbsp;&nbsp;<input class="form-control w-90 inline-block" placeholder="" type="text"  v-model="aProduct.discount" @keypress="returnNum">&nbsp;&nbsp;元
                      &nbsp;&nbsp;<button class="btn btn-success" @click="sameItem(activity.strategy_data.setting.product_info, aIndex)">全部套用</button>
                    </td>
                    <td v-else>
                      購買&nbsp;&nbsp;{{aProduct.amount_unit}}&nbsp;&nbsp;個
                      折&nbsp;&nbsp;{{aProduct.discount}}&nbsp;&nbsp;元
                    </td>
                    <td v-if="!info.info.has_used">
                      <button class="btn btn-danger" @click="removeListItem(activity.strategy_data.setting.product_info, aIndex)"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.setting.exception_products.length && ruleCode === 'SD00003'">
                <table class="table table-bordered table-striped dataTable">
                  <thead class="bg-primary">
                  <tr>
                    <td>＃</td>
                    <td>商品</td>
                    <td>商品料號</td>
                    <td v-if="!info.info.has_used"></td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(aProduct, aIndex) in activity.strategy_data.setting.exception_products">
                    <td>
                      {{aIndex + 1}}
                    </td>
                    <td>
                      {{aProduct.product_name}}
                    </td>
                    <td>
                      <div class="text-primary c-pointer" data-toggle="modal" v-if="$route.params.activity_id"
                           data-target="#storeProdModal" @click="getStoreProd(aProduct)">{{aProduct.vendor_custom_id}}</div>
                      <div v-else>{{aProduct.vendor_custom_id}}</div>
                    </td>
                    <td v-if="!info.info.has_used">
                      <button class="btn btn-danger" @click="removeListItem(activity.strategy_data.setting.exception_products, aIndex)"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.box-body -->
    <div class="box-footer text-center">
      <button class="btn btn-fail" @click="$router.go(-1)">
        取消
      </button>
      <button class="btn btn-success" @click="checkActivity" v-if="info.info.activity_id">
        修改
      </button>
      <button class="btn btn-success" @click="checkActivity" v-else>
        新增
      </button>
    </div>
    <!-- modal -->
    <m-modal :option="delOption" @trigger="trigger"></m-modal>
    <div class="modal fade" role="dialog" id="storeProdModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{curVCID}} 出現的門市</h4>
          </div>
          <div class="modal-body">
            <table class="table table-bordered table-striped dataTable">
              <thead class="bg-primary">
              <tr>
                <td>＃</td>
                <td>商品 (ID)</td>
                <td>門市</td>
                <td>菜單</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(sProd, aIndex) in storeProdList">
                <td>
                  {{aIndex + 1}}
                </td>
                <td>
                  <div v-if="sProd.product_id">
                    {{sProd.product_name}} ({{sProd.product_id}})
                  </div>
                  <div class="text-red" v-else>無對應的商品</div>
                </td>
                <td>{{sProd.store_name}}</td>
                <td>
                  <div v-if="sProd.menu_id">
                    {{sProd.menu_name}}
                  </div>
                  <div class="text-red" v-else>無使用中菜單</div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- 你訂 & 街口提醒 -->
    <button class="btn" ref="warnModal" v-show="false" data-toggle="modal" data-target="#warnModal"></button>
    <div class="modal fade" role="dialog" id="warnModal" aria-hidden="true" tabindex="-1" >
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">提醒</h4>
          </div>
          <div class="modal-body">
            <div class="box-body form p-x-0">
              <div>
                如欲調整揭露平台，請按右上角聯絡客服
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">確定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import menuDiscount from './MenuDiscountTemp.vue'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
export default {
  props: ['isUp'],
  components: {
    'date-time-picker': datetimePicker,
    'menu-discount': menuDiscount
  },
  data () {
    return {
      setInfoTimes: 0,
      info: {
        info: {}
      },
      reNew: 0,
      reSet: 0,
      ruleCode: 'SD00002',
      brandSelect: {
        label: '',
        value: ''
      },
      menuSelect: {
        label: '',
        value: 0
      },
      // modal test
      ownerTypeOptions: [
        {label: '品牌', value: 2},
        {label: '門市', value: 3},
        {label: '平台', value: 1}
      ],
      enableOptions: [
        {label: '啟用', value: 1},
        {label: '停用', value: 0}
      ],
      timeTypeOption: [
        {label: '全時段', value: 1},
        {label: '指定時段', value: 2}
      ],
      orderType: [
        {label: '一般單', value: 1},
        {label: '團購單', value: 2}
      ],
      orderMethod: [
        {label: '當日單', value: 1},
        {label: '預訂單', value: 2}
      ],
      deliveryType: [
        {label: '自取', value: 1},
        {label: '內用', value: 2},
        {label: '外送', value: 3},
        {label: '內用-桌邊掃碼', value: 21}
      ],
      tradeType: [],
      menuList: [],
      addStoresSetting: {
        class: 'buy-add-store',
        options: [],
        choose: []
      },
      priceType: [
        {label: '免稅', value: 1},
        {label: '未稅', value: 2},
        {label: '含稅', value: 3}
      ],
      couponSetting: [
        {label: '依訂單購買商品數設定', value: 'SC00001'},
        {label: '依個人訂單消費特定商品數', value: 'SC00002'},
        {label: '依個人訂單購買金額', value: 'SC00003'}
      ],
      useType: [
        {label: '品牌型', value: 2},
        {label: '門市型', value: 3}
      ],
      usageValue: [],
      brandList: [],
      content: {
        bindingStoreList: [],
        bindingBrandList: [],
        bindingProdList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false
      },
      tableIndex: 1,
      count: 20,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      timeoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          from: moment().add(-1, 'days').format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          from: moment().add(-1, 'days').format('YYYY-MM-DD')
        }
      ],
      offdaySetting: {
        date: [],
        weekDay: [],
        monthDay: [],
        options: {
          date: [
            // {label: '無指定', value: 0}
          ],
          weekDay: [
            // {label: '無指定', value: 0},
            {label: '週日', value: 1},
            {label: '週一', value: 2},
            {label: '週二', value: 3},
            {label: '週三', value: 4},
            {label: '週四', value: 5},
            {label: '週五', value: 6},
            {label: '週六', value: 7}
          ],
          month: [
            // {label: '無指定', value: 0},
            {label: '一月', value: 1},
            {label: '二月', value: 2},
            {label: '三月', value: 3},
            {label: '四月', value: 4},
            {label: '五月', value: 5},
            {label: '六月', value: 6},
            {label: '七月', value: 7},
            {label: '八月', value: 8},
            {label: '九月', value: 9},
            {label: '十月', value: 10},
            {label: '十一月', value: 11},
            {label: '十二月', value: 12}
          ],
          monthDay: [
            // {label: '無指定', value: 0}
          ]
        }
      },
      timeSettingList: [
        { value_type: 0, start_value: 0, end_value: 0, time_type: 1, time_interval: [] }
      ],
      activity: {
        name: '',
        description: '',
        rule_code: 'SD00002',
        start_date: '',
        end_date: '',
        is_enable: {label: '啟用', value: 1},
        owner_type: {label: '品牌', value: 2},
        owner_id: 0,
        aTime: {
          type: null,
          start: { time: '' },
          end: { time: '' }
        },
        is_platform_visible: {label: '啟用', value: 1},
        dedicated_visible_setting: {label: '停用', value: 0},
        time_setting: [],
        store_ids: [],
        strategy_data: {
          limit: {
            delivery_types: [],
            order_types: [],
            trade_types: [],
            order_methods: [],
            min_product_money: '',
            min_product_amount: '',
            min_sub_order_amount: ''
          },
          setting: {
            // SD00002
            one_max_discount: '',
            product_info: [],
            // SD00001、SD00003
            amount_unit: '',
            // SD00003
            lowest_unit_price: 0,
            ratio: '',
            exception_products: [],
            // SD00004
            percent_value: '',
            ignore_allowance: { label: '不忽略折讓(A+B)金額，商品總額扣除折讓計算', value: 0 },
            round_policy: { label: '小數四折五入', value: 'round' },
            // SD00005
            discount_unit: ''
          },
          // SD00001
          store_exception_items: [
            {
              products: [],
              store_ids: []
            }
          ]
        }
      },
      productBrief: [],
      productChoseBrief: [],
      nowTime: moment().format('YYYY-MM-DD HH:mm'),
      storeList: [],
      storeSelect: {label: '', value: ''},
      delOption: {
        id: 'delModal',
        title: '刪除折扣活動',
        body: '刪除折扣活動，將活動標註為刪除',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delDiscount'
          }
        ]
      },
      storeClassList: [],
      curId: 0,
      storeProdList: [],
      curVCID: '',
      ignoreAllowance: [
        { label: '不忽略折讓(A+B)金額，商品總額扣除折讓計算', value: 0 },
        { label: '忽略折讓(A+B)金額，商品總額不扣除折讓計算', value: 1 }
      ],
      roundPolicy: [
        { label: '小數四折五入', value: 'round' },
        { label: '小數無條件捨去', value: 'floor' },
        { label: '小數無條件進位', value: 'ceil' }
      ]
    }
  },
  created () {
    if (this.$route.query.rule_code) {
      this.activity.rule_code = this.$route.query.rule_code
      this.ruleCode = this.$route.query.rule_code
    }
    this.getBrandBrief()
    this.getTradeTypeList()
    // 店家
    if (this.getRoleType === 10) {
      this.useType = [
        {label: '品牌型', value: 2},
        {label: '門市型', value: 3}
      ]
    }
    // this.getStoreBrief()
  },
  methods: {
    ...mapActions(['setMenuStartTime', 'setMenuEndTime']),
    getStoreProd (prod) {
      this.curVCID = prod.vendor_custom_id
      const self = this
      const vcId = prod.vendor_custom_id
      var url = '/discount/' + this.$route.params.activity_id + '/storeOnlineProduct?vendor_custom_id=' + vcId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeProdList = response.data.list
        }
      })
    },
    getStoreClassList (brandId) {
      var self = this
      var url = '/brand/' + brandId + '/storeClassList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          self.storeClassList = sList
        }
      })
    },
    clickOption (option) {
      var self = this
      this.addStoresSetting.options = []
      self.curId = option.id
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++
          self.addStoresSetting.options = self.storeBrief
          self.getCurStoreClass()
        })
      }
    },
    getCurStoreClass () {
      this.addStoresSetting.choose = []
      var self = this
      var url = '/brand/' + this.brandSelect.value + '/storeClass/' + this.curId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id)
            // console.log(self.addStoresSetting.choose)
            // console.log(s)
          })
        }
      })
    },
    trigger (event) {
      if (event === 'delDiscount') {
        this.delDiscount()
      }
    },
    delDiscount () {
      var self = this
      var url = '/discount/' + this.$route.params.activity_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/upDiscountList')
        }
      })
    },
    returnNum (e) {
      var charCode = (e.which) ? e.which : e.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault()
      } else {
        return true
      }
    },
    addProdToList (addPInfo) {
      var self = this
      var pInfo = this.activity.strategy_data.setting.product_info
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id
        })
        if (!isSame) pInfo.push(addP)
        else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          })
        }
      })
    },
    addExProdToList (addPInfo) {
      var self = this
      var pInfo = this.activity.strategy_data.store_exception_items[0].products
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id
        })
        if (!isSame) {
          pInfo.push(addP)
        } else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          })
        }
      })
    },
    addExProdToList3  (addPInfo) {
      var self = this
      var pInfo = this.activity.strategy_data.setting.exception_products
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id
        })
        if (!isSame) pInfo.push(addP)
        else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          })
        }
      })
    },
    sameItem (list, index) {
      var getAmount = list[index].amount_unit
      var getDiscount = list[index].discount
      list.forEach(function (o) {
        o.amount_unit = getAmount
        o.discount = getDiscount
      })
    },
    removeListItem (list, index) {
      list.splice(index, 1)
    },
    clearProcess (process) {
      process.end_value = ''
      process.start_value = ''
    },
    changeTimeType (process) {
      if (process.time_type === 2) {
        var item = {
          start_time: '',
          end_time: ''
        }
        if (!process.time_interval.length) process.time_interval.push(item)
      } else {
        process.time_interval = []
      }
    },
    addProcessTime () {
      var timeSetting = { value_type: 0, start_value: 0, end_value: 0, time_type: 1, time_interval: [] }
      this.timeSettingList.push(timeSetting)
    },
    addChooseTag (newTag) {
      const tag = {
        name: newTag,
        id: ''
      }
      this.productChoseBrief.push(tag)
      this.activity.setting.vendorCustomProductList.push(tag)
    },
    addItemTime (process) {
      var item = {
        start_time: '',
        end_time: ''
      }
      process.time_interval.push(item)
    },
    addStartMonthDayTag (newTag, id) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.monthDay.push(tag)
      // this.offdaySetting.monthDay.push(tag)
    },
    addEndMonthDayTag (newTag, id) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.monthDay.push(tag)
      // this.offdaySetting.monthDay.push(tag)
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      this.addStoresSetting.options = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            self.addStoresSetting.options.push(obj)
          }
          if (self.$route.name.indexOf('up') > -1 && !self.setInfoTimes) self.getDiscountInfo()
          else if (self.info.info.activity_id && self.setInfoTimes === 1) self.setStore()
          self.reNew++
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            if (i === 0) self.brandSelect = obj
          }
        }
      })
    },
    getDiscountInfo () {
      var self = this
      var url = '/discount/' + this.$route.params.activity_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data
          self.setInfo()
        }
      })
    },
    setStore () {
      var self = this
      let stores = this.info.attend_stores
      // console.log(stores)
      if (stores.length) {
        stores[0].store_list.forEach(function (store) {
          self.addStoresSetting.choose.push(store.store_id)
        })
      }
    },
    setInfo () {
      this.setInfoTimes++
      let a = this.activity
      let i = this.info.info
      let times = this.info.time_setting
      let strategy = this.info.strategy_data[0]
      let stores = this.info.attend_stores
      var self = this
      a.name = i.name
      a.description = i.description
      a.rule_code = this.ruleCode = i.rule_code
      // date
      a.aTime.type = i.time_src_type
      a.aTime.start.time = i.start_date
      a.aTime.end.time = i.end_date
      a.is_enable = this.enableOptions.find(function (o) { return o.value === i.is_enable })
      a.is_platform_visible = this.enableOptions.find(function (o) { return o.value === i.is_platform_visible })
      if (i.dedicated_visible_setting.length > 0) {
        a.dedicated_visible_setting = this.enableOptions.find(function (o) {
          return o.value === i.dedicated_visible_setting[0]
        })
      }
      a.owner_type = this.ownerTypeOptions.find(function (o) { return o.value === i.owner_type })
      this.brandSelect = this.brandBrief.find(function (o) { return o.value === stores[0].brand_id }) // 取參與店家裡的品牌
      if (this.brandSelect.value === this.brandBrief[0].value) this.setStore() // 不會重撈storeBrief
      this.timeSettingList = []
      times.forEach(function (time) {
        let option = {}
        if (time.value_type === 2) {
          option = {
            end_value: self.offdaySetting.options.weekDay.find(function (wd) { return wd.value === time.end_value }),
            start_value: self.offdaySetting.options.weekDay.find(function (wd) { return wd.value === time.start_value }),
            time_type: time.time_type,
            value_type: time.value_type,
            time_interval: time.time_interval
          }
          self.timeSettingList.push(option)
        } else {
          option = {
            end_value: time.end_value,
            start_value: time.start_value,
            time_type: time.time_type,
            value_type: time.value_type,
            time_interval: time.time_interval
          }
          self.timeSettingList.push(option)
        }
      })
      if (a.rule_code === 'SD00001') {
        let iLimit = strategy.limit
        let aLimit = a.strategy_data.limit
        // limit
        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) { return o.value === dType }))
          })
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) { return o.value === oType }))
          })
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) { return o.value === tType }))
          })
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) { return o.value === oMethod }))
          })
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount
        // setting
        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit
        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name)
          })
        }
      } else if (a.rule_code === 'SD00002') {
        let iLimit = strategy.limit
        let aLimit = a.strategy_data.limit
        // limit
        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) { return o.value === dType }))
          })
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) { return o.value === oType }))
          })
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) { return o.value === tType }))
          })
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) { return o.value === oMethod }))
          })
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount
        // setting
        if (strategy.setting.one_max_discount) a.strategy_data.setting.one_max_discount = strategy.setting.one_max_discount
        a.strategy_data.setting.product_info = strategy.setting.product_info
      } else if (a.rule_code === 'SD00004') {
        let iLimit = strategy.limit
        let aLimit = a.strategy_data.limit
        // limit
        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) { return o.value === dType }))
          })
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) { return o.value === oType }))
          })
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) { return o.value === tType }))
          })
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) { return o.value === oMethod }))
          })
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount
        // setting
        console.log(strategy.setting)
        if (strategy.setting.percent_value) a.strategy_data.setting.percent_value = strategy.setting.percent_value
        if (strategy.setting.ignore_allowance !== '') {
          a.strategy_data.setting.ignore_allowance = this.ignoreAllowance.find(function (option) { return option.value === strategy.setting.ignore_allowance })
        }
        if (strategy.setting.round_policy) {
          a.strategy_data.setting.round_policy = this.roundPolicy.find(function (option) { return option.value === strategy.setting.round_policy })
        }
        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name)
          })
        }
      } else if (a.rule_code === 'SD00005') {
        let iLimit = strategy.limit
        let aLimit = a.strategy_data.limit
        // limit
        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) { return o.value === dType }))
          })
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) { return o.value === oType }))
          })
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) { return o.value === tType }))
          })
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) { return o.value === oMethod }))
          })
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount
        // setting
        console.log(strategy.setting)
        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit
        if (strategy.setting.lowest_unit_price) a.strategy_data.setting.lowest_unit_price = strategy.setting.lowest_unit_price
        if (strategy.setting.discount_unit) a.strategy_data.setting.discount_unit = strategy.setting.discount_unit

        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name)
          })
        }
      } else if (a.rule_code === 'SD00003') {
        let iLimit = strategy.limit
        let aLimit = a.strategy_data.limit
        // limit
        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) { return o.value === dType }))
          })
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) { return o.value === oType }))
          })
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) { return o.value === tType }))
          })
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) { return o.value === oMethod }))
          })
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount
        // setting
        // 明天從這裡開始
        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit
        if (strategy.setting.lowest_unit_price) a.strategy_data.setting.lowest_unit_price = strategy.setting.lowest_unit_price
        if (strategy.setting.ratio) a.strategy_data.setting.ratio = strategy.setting.ratio
        if (strategy.setting.exception_products.length) {
          a.strategy_data.setting.exception_products = strategy.setting.exception_products
          strategy.setting.exception_products.forEach(function (prod, pIndex) {
            self.$set(a.strategy_data.setting.exception_products[pIndex], 'product_name', prod.name)
          })
        }
      }
      /*
      if (i.owner_type === 1) a.owner_id = 0
      else if (i.owner_type === 2) this.brandSelect.value = this.brandBrief.find(function (o) { return o.value === i.owner_id })
      */
      // else if (i.owner_type === 3) this.addStoresSetting.choose = data.store_ids[0]
    },
    getTradeTypeList () {
      var self = this
      var url = '/platform/tradeTypeList'
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = []
          var list = response.data.list
          for (var i = 0; i < list.length; i++) {
            if (list[i].is_valid && list[i].is_enable) {
              var option = {
                label: list[i].name,
                value: parseInt(list[i].type, 10)
              }
              self.tradeType.push(option)
            }
          }
        }
      })
    },
    checkActivity () {
      var a = this.activity
      var sD = a.strategy_data // 活動策略
      var msg = ''
      if (!a.name) msg = '活動名稱未填'
      else if (!a.aTime.type) msg = '活動時間類型尚未選擇'
      else if (!a.aTime.start.time) msg = '活動開始時間未填'
      else if (!a.aTime.end.time) msg = '活動結束時間未填'
      else if (!a.owner_type.value) msg = '活動擁有者未選'
      else if (!a.is_enable) msg = '活動啟用未選'
      else if (!a.is_platform_visible) msg = '你訂平台啟用未選'
      else if (!a.dedicated_visible_setting) msg = '街口平台啟用未選'
      else if (!a.description) msg = '活動描述未填'
      else if (!this.timeSettingList.length) msg = '折扣生效日未填'
      else if (!this.addStoresSetting.choose.length) msg = '參與活動店家未選'
      else if (this.addStoresSetting.choose.length > 1 && a.owner_type === 3) msg = '品牌擁有者只可選擇一家店家'
      else if (a.rule_code === 'SD00002') {
        if (!sD.setting.product_info.length) msg = '折扣商品選擇未選'
        else if (sD.setting.product_info.length) {
          sD.setting.product_info.forEach(function (pInfo) {
            if (!pInfo.discount) msg = '折扣商品 - ' + pInfo.product_name + ' 折扣金額未填'
            if (!pInfo.amount_unit) msg = '折扣商品 - ' + pInfo.product_name + ' 折扣購買數量未填'
          })
        }
      } else if (a.rule_code === 'SD00001') {
        if (!sD.setting.amount_unit) msg = '買幾份送一數值未填'
      } else if (a.rule_code === 'SD00003') {
        if (!sD.setting.amount_unit) msg = '買X份送Y，X數值未填'
        else if (!sD.setting.amount_unit) msg = '買X份送Y，Y數值未填'
        else if (sD.setting.lowest_unit_price === '') msg = '折抵最低單價未填'
      } else if (a.rule_code === 'SD00004') {
        if (!sD.setting.percent_value) msg = '折扣數值未填'
        if (sD.setting.ignore_allowance.value === '') msg = '是否忽略折讓(A+B)金額未選'
        if (sD.setting.round_policy.value === '') msg = '折扣金額小數點進位方式未選'
      } else if (a.rule_code === 'SD00005') {
        if (!sD.setting.amount_unit) msg = '累積達成數量單位未填'
        if (sD.setting.lowest_unit_price === '') msg = '商品限制最低單價未填'
        if (!sD.setting.discount_unit) msg = '每達到數量贈送的金額未填'
      }
      // 明天從這裡開始
      this.getToast(msg)
    },
    getToast (msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.setData()
      }
    },
    setData (type) {
      var act = this.activity
      var data = {
        name: act.name,
        description: act.description,
        rule_code: act.rule_code,
        time_src_type: act.aTime.type,
        start_date: act.aTime.start.time,
        end_date: act.aTime.end.time,
        is_enable: act.is_enable.value,
        is_platform_visible: act.is_platform_visible.value,
        dedicated_visible_setting: [],
        time_setting: [],
        store_ids: this.addStoresSetting.choose
      }
      // 判斷街口平台
      if (act.dedicated_visible_setting.value === 1) {
        data.dedicated_visible_setting.push(act.dedicated_visible_setting.value)
      }
      // owner_type
      if (!this.info.info.activity_id || this.getRoleType === 99) {
        data.owner_type = act.owner_type.value
        if (this.getRoleType === 30) data.owner_type = 2
        else if (this.getRoleType === 10) data.owner_type = 3
        data.owner_id = 0
        if (data.owner_type === 1) data.owner_id = 0
        else if (data.owner_type === 2) data.owner_id = this.brandSelect.value
        else if (data.owner_type === 3) data.owner_id = data.store_ids[0]
      }
      // time_setting
      this.timeSettingList.forEach(function (time) {
        let o = {
          value_type: 0,
          start_value: 0,
          end_value: 0,
          time_type: time.time_type,
          time_interval: time.time_interval
        }
        if (time.value_type) o.value_type = time.value_type
        if (time.value_type === 2) {
          if (time.start_value.value) o.start_value = time.start_value.value
          if (time.end_value.value) o.end_value = time.end_value.value
        } else if (time.value_type === 1) {
          if (time.start_value) o.start_value = time.start_value
          if (time.end_value) o.end_value = time.end_value
        }
        data.time_setting.push(o)
      })
      // 沒有被使用才傳入
      if (!this.info.info.has_used) {
        data.strategy_data = {}
        let aSD = act.strategy_data
        if (act.rule_code === 'SD00001') {
          data.strategy_data = {
            limit: {},
            setting: {
              amount_unit: aSD.setting.amount_unit
            },
            store_exception_items: []
          }
          let dSD = data.strategy_data
          // limit
          if (aSD.limit.delivery_types.length) {
            dSD.limit.delivery_types = []
            aSD.limit.delivery_types.forEach(function (dType) {
              dSD.limit.delivery_types.push(dType.value)
            })
          }
          if (aSD.limit.order_types.length) {
            dSD.limit.order_types = []
            aSD.limit.order_types.forEach(function (oType) {
              dSD.limit.order_types.push(oType.value)
            })
          }
          if (aSD.limit.trade_types.length) {
            dSD.limit.trade_types = []
            aSD.limit.trade_types.forEach(function (tType) {
              dSD.limit.trade_types.push(tType.value)
            })
          }
          if (aSD.limit.order_methods.length) {
            dSD.limit.order_methods = []
            aSD.limit.order_methods.forEach(function (oMethod) {
              dSD.limit.order_methods.push(oMethod.value)
            })
          }
          if (aSD.limit.min_product_money) dSD.limit.min_product_money = aSD.limit.min_product_money
          if (aSD.limit.min_product_amount) dSD.limit.min_product_amount = aSD.limit.min_product_amount
          if (aSD.limit.min_sub_order_amount) dSD.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount
          // setting
          if (aSD.store_exception_items[0].products.length) {
            let o = {
              products: [],
              store_ids: this.addStoresSetting.choose
            }
            aSD.store_exception_items[0].products.forEach(function (product) {
              let pO = {
                vendor_custom_id: product.vendor_custom_id,
                name: product.product_name
              }
              o.products.push(pO)
            })
            dSD.store_exception_items = [o]
          }
        } else if (act.rule_code === 'SD00002') {
          data.strategy_data = {
            limit: {},
            setting: {
              one_max_discount: null,
              product_info: aSD.setting.product_info
            }
          }
          let dSD = data.strategy_data
          // limit
          if (aSD.limit.delivery_types.length) {
            dSD.limit.delivery_types = []
            aSD.limit.delivery_types.forEach(function (dType) {
              dSD.limit.delivery_types.push(dType.value)
            })
          }
          if (aSD.limit.order_types.length) {
            dSD.limit.order_types = []
            aSD.limit.order_types.forEach(function (oType) {
              dSD.limit.order_types.push(oType.value)
            })
          }
          if (aSD.limit.trade_types.length) {
            dSD.limit.trade_types = []
            aSD.limit.trade_types.forEach(function (tType) {
              dSD.limit.trade_types.push(tType.value)
            })
          }
          if (aSD.limit.order_methods.length) {
            dSD.limit.order_methods = []
            aSD.limit.order_methods.forEach(function (oMethod) {
              dSD.limit.order_methods.push(oMethod.value)
            })
          }
          if (aSD.limit.min_product_money) dSD.limit.min_product_money = aSD.limit.min_product_money
          if (aSD.limit.min_product_amount) dSD.limit.min_product_amount = aSD.limit.min_product_amount
          if (aSD.limit.min_sub_order_amount) dSD.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount
          // setting
          if (aSD.setting.one_max_discount) dSD.setting.one_max_discount = aSD.setting.one_max_discount
        } else if (act.rule_code === 'SD00003') {
          data.strategy_data = {
            limit: {},
            setting: {
              amount_unit: aSD.setting.amount_unit,
              lowest_unit_price: aSD.setting.lowest_unit_price,
              ratio: aSD.setting.ratio,
              exception_products: []
            }
          }
          let dSD = data.strategy_data
          // limit
          if (aSD.limit.delivery_types.length) {
            dSD.limit.delivery_types = []
            aSD.limit.delivery_types.forEach(function (dType) {
              dSD.limit.delivery_types.push(dType.value)
            })
          }
          if (aSD.limit.order_types.length) {
            dSD.limit.order_types = []
            aSD.limit.order_types.forEach(function (oType) {
              dSD.limit.order_types.push(oType.value)
            })
          }
          if (aSD.limit.trade_types.length) {
            dSD.limit.trade_types = []
            aSD.limit.trade_types.forEach(function (tType) {
              dSD.limit.trade_types.push(tType.value)
            })
          }
          if (aSD.limit.order_methods.length) {
            dSD.limit.order_methods = []
            aSD.limit.order_methods.forEach(function (oMethod) {
              dSD.limit.order_methods.push(oMethod.value)
            })
          }
          if (aSD.limit.min_product_money) dSD.limit.min_product_money = aSD.limit.min_product_money
          if (aSD.limit.min_product_amount) dSD.limit.min_product_amount = aSD.limit.min_product_amount
          if (aSD.limit.min_sub_order_amount) dSD.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount
          // setting
          if (aSD.setting.exception_products.length) {
            aSD.setting.exception_products.forEach(function (product) {
              let pO = {
                vendor_custom_id: product.vendor_custom_id,
                name: product.product_name
              }
              dSD.setting.exception_products.push(pO)
            })
          }
        } else if (act.rule_code === 'SD00004') {
          data.strategy_data = {
            limit: {},
            setting: {
              percent_value: aSD.setting.percent_value,
              ignore_allowance: aSD.setting.ignore_allowance.value,
              round_policy: aSD.setting.round_policy.value
            },
            store_exception_items: []
          }
          let dSD = data.strategy_data
          // limit
          if (aSD.limit.delivery_types.length) {
            dSD.limit.delivery_types = []
            aSD.limit.delivery_types.forEach(function (dType) {
              dSD.limit.delivery_types.push(dType.value)
            })
          }
          if (aSD.limit.order_types.length) {
            dSD.limit.order_types = []
            aSD.limit.order_types.forEach(function (oType) {
              dSD.limit.order_types.push(oType.value)
            })
          }
          if (aSD.limit.trade_types.length) {
            dSD.limit.trade_types = []
            aSD.limit.trade_types.forEach(function (tType) {
              dSD.limit.trade_types.push(tType.value)
            })
          }
          if (aSD.limit.order_methods.length) {
            dSD.limit.order_methods = []
            aSD.limit.order_methods.forEach(function (oMethod) {
              dSD.limit.order_methods.push(oMethod.value)
            })
          }
          if (aSD.limit.min_product_money) dSD.limit.min_product_money = aSD.limit.min_product_money
          if (aSD.limit.min_product_amount) dSD.limit.min_product_amount = aSD.limit.min_product_amount
          if (aSD.limit.min_sub_order_amount) dSD.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount
          // setting
          if (aSD.store_exception_items[0].products.length) {
            let o = {
              products: [],
              store_ids: this.addStoresSetting.choose
            }
            aSD.store_exception_items[0].products.forEach(function (product) {
              let pO = {
                vendor_custom_id: product.vendor_custom_id,
                name: product.product_name
              }
              o.products.push(pO)
            })
            dSD.store_exception_items = [o]
          }
        } else if (act.rule_code === 'SD00005') {
          data.strategy_data = {
            limit: {},
            setting: {
              amount_unit: aSD.setting.amount_unit,
              lowest_unit_price: aSD.setting.lowest_unit_price,
              discount_unit: aSD.setting.discount_unit
            },
            store_exception_items: []
          }
          let dSD = data.strategy_data
          // limit
          if (aSD.limit.delivery_types.length) {
            dSD.limit.delivery_types = []
            aSD.limit.delivery_types.forEach(function (dType) {
              dSD.limit.delivery_types.push(dType.value)
            })
          }
          if (aSD.limit.order_types.length) {
            dSD.limit.order_types = []
            aSD.limit.order_types.forEach(function (oType) {
              dSD.limit.order_types.push(oType.value)
            })
          }
          if (aSD.limit.trade_types.length) {
            dSD.limit.trade_types = []
            aSD.limit.trade_types.forEach(function (tType) {
              dSD.limit.trade_types.push(tType.value)
            })
          }
          if (aSD.limit.order_methods.length) {
            dSD.limit.order_methods = []
            aSD.limit.order_methods.forEach(function (oMethod) {
              dSD.limit.order_methods.push(oMethod.value)
            })
          }
          if (aSD.limit.min_product_money) dSD.limit.min_product_money = aSD.limit.min_product_money
          if (aSD.limit.min_product_amount) dSD.limit.min_product_amount = aSD.limit.min_product_amount
          if (aSD.limit.min_sub_order_amount) dSD.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount
          // setting
          if (aSD.store_exception_items[0].products.length) {
            let o = {
              products: [],
              store_ids: this.addStoresSetting.choose
            }
            aSD.store_exception_items[0].products.forEach(function (product) {
              let pO = {
                vendor_custom_id: product.vendor_custom_id,
                name: product.product_name
              }
              o.products.push(pO)
            })
            dSD.store_exception_items = [o]
          }
        }
      }
      // console.log(data)
      if (this.info.info.activity_id) this.upDiscount(data)
      else this.crDiscount(data)
    },
    crDiscount (data) {
      var self = this
      var url = '/discount'
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/upDiscountList')
          // self.$router.go(-1)
          // self.total = response.data.total
        }
      })
    },
    upDiscount (data) {
      var self = this
      var url = '/discount/' + this.$route.params.activity_id
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          // self.$router.replace('/upDiscountList')
          self.$router.go(-1)
          // self.total = response.data.total
        }
      })
    },
    getOnlineMenu () {
      var self = this
      self.menuList = []
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + this.brandSelect.value + '&store_id=' + this.storeSelect.value
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var mList = response.data.menu_list
          mList.forEach(function (menu, index) {
            var option = {label: menu.name, value: menu.id}
            self.menuList.push(option)
            if (index === 0) self.menuSelect = option
          })
          if (!mList.length) self.menuSelect = {label: '', value: ''}
          // self.total = response.data.total
        }
      })
    },
    getPlaceholder (val = []) {
      if (!Array.isArray(val)) return []
      return val.map((i) => {
        return i.label
      }).join('、')
    },
    showWarning () {
      // brand & store 權限彈出提醒視窗
      if (this.getRoleType !== 99) {
        this.$refs.warnModal.click()
      }
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    },
    selectStorePadding () {
      if (this.$route.query.rule_code === 'SD00003') {
        return 'padding-right: 165px'
      } else if (this.$route.query.rule_code === 'SD00004') {
        return 'padding-right: 190px'
      } else if (this.$route.query.rule_code === 'SD00005') {
        return 'padding-right: 45px'
      }
      return ''
    },
    activityInfo () {
      let temp = {
        title: '',
        info: '',
        description: '',
        strategyDataLimitOrderTypes: '',
        strategyDataSettingLowestUnitPriceTips: '',
        strategyDataSettingPercentValueTips: '',
        strategyDataSettingIgnoreAllowanceTips: '',
        strategyDataSettingRoundPolicyTips: '',
        strategyDataSettingAmountUnitTips: '',
        strategyDataSettingDiscountUnitTips: ''
      }
      const ruleCode = this.$route.query.rule_code || this.activity.rule_code
      switch (ruleCode) {
        case 'SD00002':
          temp.title = '指定商品X份折Y元'
          temp.description = '請寫出活動日期與詳細折扣規則，如：3/1~3/30 自取訂單滿100元(含)以上，奶茶系列商品折5元，品牌擁有做最後說明調整的權利，你訂線上訂餐專屬優惠，此優惠不與其他優惠折扣併用。'
          temp.strategyDataSettingOneMaxDiscountTips = '整筆訂單最大總折扣金額，如填寫100，最多可折100元'
          break
        case 'SD00003':
          temp.title = '買X份商品送Y份商品'
          temp.info = '如設定買5送1活動為買5送1、買10送2，以此類推無折抵上限，折扣方式：買5杯送1杯，滿6杯折抵最低價那1杯的商品金額。'
          temp.description = '請寫出活動日期與詳細折扣規則，如：3/1~3/30 自取訂單買5送1，訂單需滿6份商品，折抵最低價商品金額，鮮奶茶系列商品不列入優惠折扣計算，品牌擁有做最後說明調整的權利，你訂線上訂餐專屬優惠，此優惠不與其他優惠折扣併用。'
          temp.strategyDataLimitOrderTypes = '如：買5送1，X數值請填5，Y數值請填1'
          temp.strategyDataSettingLowestUnitPriceTips = '可能使用情境：選購30元以上商品，即可參與買5送1活動，則會使用此限制做排除。舉例說明：填寫30，低於30元的品項不列入買X份的份數計算'
          break
        case 'SD00004':
          temp.title = '訂單打X折'
          temp.description = '請寫出活動日期與詳細折扣規則，如：3/1~3/30 自取訂單滿100元(含)以上享9折優惠，鮮奶茶系列商品不列入優惠折扣計算，品牌擁有做最後說明調整的權利，你訂線上訂餐專屬優惠，此優惠不與其他優惠折扣併用。'
          temp.strategyDataSettingPercentValueTips = '如85折為15%，請輸入15、9折為10%，請輸入10'
          temp.strategyDataSettingIgnoreAllowanceTips = '特殊POS使用，不需做任何調整'
          temp.strategyDataSettingRoundPolicyTips = '如：全品項85折，消費者買75元飲品，折扣金額為75*(1-0.85)=11.25，選擇四捨五入訂單折扣折11元，小數無條件進位折12元，小數無條件捨去折11元'
          break
        case 'SD00005':
          temp.title = '買X份商品折Y元'
          temp.info = '如：設定買5份商品折20元，折扣活動為買5份商品折20元、買10份商品折40元，以此類推無折抵上限。'
          temp.description = '請寫出活動日期與詳細折扣規則，如：3/1~3/30 自取訂單滿5份商品折20元、滿10份商品折40元，以此類推，鮮奶茶系列商品不列入優惠折扣計算，品牌擁有做最後說明調整的權利，你訂線上訂餐專屬優惠，此優惠不與其他優惠折扣併用。'
          temp.strategyDataSettingAmountUnitTips = '如買5份商品折20元，請輸入5'
          temp.strategyDataSettingLowestUnitPriceTips = '可能使用情境：選購30元以上商品，即可參與買X商品折Y元活動，則會使用此限制做排除。舉例說明：填寫30，低於30元的品項不列入買X份的份數計算'
          temp.strategyDataSettingDiscountUnitTips = '如買5份商品折20元，請輸入20'
          break
        default:
          break
      }
      return temp
    }
  },
  watch: {
    'menuTime.start.time' () {
      this.endLimit = [
        {
          type: 'fromto',
          from: this.menuTime.start.time
        }
      ]
      this.setMenuStartTime(this.menuTime.start.time)
    },
    'menuTime.end.time' () {
      this.startLimit = [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss'),
          to: this.menuTime.end.time
        }
      ]
      this.setMenuEndTime(this.menuTime.end.time)
    },
    'content.bindingBrandList' () {
      var self = this
      this.storeBrief = []
      this.content.bindingStoreList = []
      this.content.bindingBrandList.forEach(function (array) {
        const brandId = array.value
        self.getStoreBrief(brandId)
      })
    },
    'addStoresSetting.choose' () {
      var self = this
      this.activity.store_ids = this.addStoresSetting.choose
      this.storeList = []
      this.addStoresSetting.choose.forEach(function (id) {
        self.addStoresSetting.options.find(function (o) {
          if (o.value === id) self.storeList.push(o)
        })
      })
      if (this.storeList.length) this.storeSelect = this.storeList[0]
    },
    'brandSelect.value' () {
      this.getStoreBrief(this.brandSelect.value)
      this.addStoresSetting.choose = []
      if (this.brandSelect.value && this.getRoleType !== 10) {
        this.curId = 0
        this.getStoreClassList(this.brandSelect.value)
      }
    },
    'storeSelect.value' () {
      if (this.storeSelect.value) this.getOnlineMenu()
    }
  }
}
</script>
<style lang="sass">
.broder-all
  border: 1px solid #E1E1E1;
.coupon-left
  float: left
  width: calc(100% / 3 * 2 + 15px)
  padding-right: 5px
.coupon-right
  float: left
  background: #3c8dbc
  width: calc(100% / 3 - 15px)
  position: absolute
  right: 0
  top: 0
  height: 100%
  border-left: 5px black dashed
  border-radius: 0px 6px 6px 0px
  color: white
  .v-middle
    position: absolute
    top: calc(50% - 28.5px)
    font-size: 40px
    text-align: center
    width: 100%
    left: 0
</style>
<style lang="sass" scoped>
.tip-icon-block
  padding-right: 25px
.tip-icon
  position: absolute
  top: 9px
  left: 110px
  color: white
// .ranges
  display: none
.coupon.form-left, .coupon.form-right
  width: 50%
  float: left
.coupon.form-right
  padding: 20px 20px 20px 10px
.coupon.form-left
  padding: 20px 10px 20px 20px
.coupon.form-left.w-100-p
  padding: 20px 20px
.min-item.active, .hour-item.active, .day.checked
  background: #222d32 !important
.w-200
  width: 180px !important
.m-b-15
  margin-bottom: 15px !important
.btn-all-store
  position: absolute
  right: 10px
  z-index: 30
  top: 0px
.input-white
  border: 0px
@media screen and (max-width: 767px)
  .p-sm-10-p
    padding-right: 10px !important
    padding-left: 10px !important
@media screen and (min-width: 768px)
  .p-sm-10-p
    padding-right: calc(20% - 15px) !important
    padding-left: calc(20% + 10px) !important
@media screen and (min-width: 991px)
  .p-sm-10-p
    padding-right: calc(10% - 10px) !important
    padding-left: 10% !important
</style>
<style lang="sass">
  .multiselect__content-wrapper, .multiselect__content-wrapper *
    z-index: 99
  .m-t-0
    margin-top: 0px
  .input-group .form-control
    z-index: auto !important
  textarea
    max-width: 100%
    min-widht: 100%
  .modal-title
    width: calc(100% - 20px)
  .page-title
    color: #367FA9
    padding-top: 40px
    padding-bottom: 30px
  .sub-title
    font-weight: 700
    margin-top: 56px
    text-align: center
  .alert-info-bg
    background-color: #3C8DBC1A
  .input-group .cov-vue-date.w-100 .cov-datepicker
    max-width: 100%
</style>



// WEBPACK FOOTER //
// DiscountForm.vue?3c014d80